import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';

export default function BannerScheduleMeeting() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 3, md: 4 },
        px: { xs: 2, md: 4 },
        position: 'relative',
        backgroundImage: 'url("/images/background-image.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.95) 100%)',
          zIndex: 1,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '60px',
          height: '3px',
          background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
          borderRadius: '0 0 3px 3px',
          zIndex: 3,
        },
      }}
    >
      <Box
        sx={{
          maxWidth: '800px',
          margin: 'auto',
          textAlign: 'center',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Barlow, sans-serif',
            fontSize: { xs: '1.5rem', md: '2rem' },
            fontWeight: 700,
            color: 'white',
            mb: 1,
            lineHeight: 1.3,
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
          }}
        >
          {t('BannerScheduleHubspot00')}
        </Typography>

        <Typography
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            fontFamily: 'Barlow, sans-serif',
            fontSize: { xs: '0.9rem', md: '1rem' },
            lineHeight: 1.5,
            mb: 3,
            maxWidth: '500px',
            margin: '0 auto 24px auto',
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
          }}
        >
          {t('BannerScheduleHubspot01')}
        </Typography>

        <Button
          variant="outlined"
          endIcon={<ArrowOutwardRoundedIcon />}
          onClick={() => {
            window.location.href = '/clubs';
          }}
          sx={{
            border: '2px solid #048cec',
            borderRadius: '25px',
            px: 3,
            py: 1,
            fontSize: '0.9rem',
            fontWeight: 600,
            textTransform: 'none',
            color: '#048cec',
            background: 'transparent',
            position: 'relative',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
            minWidth: 'auto',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
              borderRadius: '25px',
              transition: 'left 0.3s ease',
              zIndex: -1,
            },
            '&:hover': {
              color: 'white',
              border: '2px solid transparent',
              transform: 'translateY(-1px)',
              '&::before': {
                left: 0,
              },
            },
          }}
        >
          {t('BannerScheduleMeeting00')}
        </Button>
      </Box>
    </Box>
  );
};